import React from "react";
import { QuestionBox } from "../shared/QuestionBox";
import { Heading } from "../shared/Heading";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { useContext } from "../../../../../context";
import { Options } from "../shared/Options";
import { BLOCK_FIELDS } from "../../../../../config";

export const YesNo = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey.preview",
  });

  const { blocks, previewAnswers } = useContext();
  const block = blocks.getCurrent();

  return (
    <QuestionBox>
      <Heading
        title={block[BLOCK_FIELDS.question]}
        description={block[BLOCK_FIELDS.description]}
        index={blocks.getCurrentIndex() + 1}
      />
      <Options
        list={[t("yes"), t("no")]}
        selected={[previewAnswers.get(block.id)]}
        onSelect={(value) => previewAnswers.set(block.id, value)}
      />
    </QuestionBox>
  );
};
